export const logo = require('./mrcs.png'); 
export const logo2 = require('./logo2.png');